$(document).ready(function(){
  var youtube = document.querySelectorAll( ".youtube" );
  for (var i = 0; i < youtube.length; i++) {
    var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/maxresdefault.jpg";
    var image = new Image();
    image.src = source;
    image.setAttribute("width", "100%");
    image.setAttribute("height", "100%");
    image.addEventListener( "load", function() {
      youtube[ i ].appendChild( image );
    }( i ) );
    youtube[i].addEventListener( "click", function() {	
      var iframe = document.createElement( "iframe" );
      iframe.setAttribute( "frameborder", "0" );
      iframe.setAttribute( "allowfullscreen", "" );
      iframe.setAttribute("width", "1000");
      iframe.setAttribute("height", "auto");
      iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?loop=1&autoplay=1&rel=0&showinfo=0&playlist=Od9-NuFohqk" );
      this.innerHTML = "";
      this.appendChild( iframe );
      $('.youtube').find('.play-button').remove();
    });
  }
});